import moment from "moment";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { stringAvatar } from "../../../../../../Utils/avatar";
import {
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import { Avatar } from "@mui/material";
import { useTimesheetProvider } from "../../../../../../Providers/Vendor/Timesheet";
import Back from "../../../../../../Components/Back";
import CustomTable from "../../../../../../Components/Table";
import { timesheetStatus } from "../../../../../../Utils/constants";
import { LinkIcon } from "@heroicons/react/24/outline";
import Swal from "sweetalert2";
import isEmail from "validator/lib/isEmail";
import isInt from "validator/lib/isInt";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button, Modal } from "antd";
import api from "../../../../../../Utils/api";
import {
  Autocomplete,
  Checkbox,
  Chip,
  FormControlLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useJobProvider } from "../../../../../../Providers/Vendor/Jobs";

const apiPath = {
  fetchTimesheetDetails: "/timesheet/gettimesheetdetails",
  fetchTimesheetLinkDetails: "/timesheet/link/gettimesheetid",
};

const Daywise = ({
  showDatePicker = false,
  hideJobInfo = false,
  setShowTimesheetDetails,
}) => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(timesheetStatus.none);
  const [job, setJob] = useState()
  const [date, setDate] = useState({
    date: moment.utc(job?.startDate).startOf("week"),
    fromApi: false,
  });

  // Modal
  const [modalOpen, setModalOpen] = useState(false);
  const [modal, setModal] = useState({
    open: false,
    type: timesheetStatus.approved,
  });
  const [emails, setEmails] = useState([]);
  const [secure, setSecure] = useState(false);
  const [pin, setPin] = useState("");
  const [comment, setComment] = useState("");
  const [numberOfWeeks, setNumberOfWeeks] = useState("");
  const [currentTimesheet, setCurrentTimesheet] = useState({});
  const [timesheetResource, setTimesheetResource] = useState({});
  const [timesheetMaster, setTimesheetMaster] = useState({});
  const username = useSelector((state) => state.user.details.username);

  const handleChange = (event) => {
    setNumberOfWeeks(event.target.value);
  };

  const { fetchJobDetails } = useJobProvider()

  const {
    selectedTimesheet,
    timesheetDetails,
    setSelectedTimesheet,
    timesheets,
    approveTimesheet,
    rejectTimesheet,
    fetchTimesheetsByDate,
    generateSecureLink,
    resourceVendor,
    canApproveTimesheet,
    fetchTimesheets
  } = useTimesheetProvider();

  const [rows, setRows] = useState([]);
  const { token, timesheetid, id } = useParams();

  useEffect(() => {
    fetchJobDetails(id).then(setJob);
    console.log(timesheetid)
    setSelectedTimesheet(timesheetid)
  }, [])

  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname

  useEffect(() => {
    fetchTimesheets();
  }, []);

  useEffect(() => {
    if (timesheets.length > 0) {
      const cur = timesheets?.find((t) => t.id === selectedTimesheet);
      setCurrentTimesheet(cur);
      setStatus(cur?.status ?? timesheetStatus.none);
    }
  }, [selectedTimesheet, timesheets]);

  useEffect(() => {
    if (timesheetDetails?.[selectedTimesheet] && timesheetDetails?.[selectedTimesheet][0]) {
      setDate({
        date: moment.utc(timesheetDetails?.[selectedTimesheet][0].date).startOf("week"),
        fromApi: false,
      });
    }
    setRows(timesheetDetails?.[selectedTimesheet] ?? []);
  }, [selectedTimesheet, timesheetDetails]);

  const fetchTimesheetDetails = async () => {
    try {
      if (token) {
        const secret = "rJK7?E@KynQ!5F39C-gy";
        const wordArray = CryptoJS.enc.Base64url.parse(token);
        const string = wordArray.toString(CryptoJS.enc.Base64);
        const bytes = CryptoJS.AES.decrypt(string, secret);
        const data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        const linkId = data?.linkId;

        if (linkId) {
          const timesheetLinkDetails = await api.get(
            apiPath.fetchTimesheetLinkDetails,
            { params: { id: linkId } }
          );

          const res = await api.get(apiPath.fetchTimesheetDetails, {
            params: {
              timesheet_id: timesheetLinkDetails.data.result,
              user_id: localStorage.getItem("userId"),
            },
          });

          if (res.data?.success) {
            setTimesheetMaster(res.data.timesheet[0]);
            setTimesheetResource(res.data.resource?.resource);
            setStatus(res.data.timesheet[0].status);
            setRows(res?.data?.result ?? [])
          } else {
            throw new Error("Error occurred while fetching timesheet details");
          }
        }
      }
    } catch (error) {
      Swal.fire("Error", "Error occurred while fetching timesheet", "error");
    }
  };

  useEffect(() => {
    fetchTimesheetDetails();
  }, [rejectTimesheet, approveTimesheet]);

  const headCells = ["Date", "Hours", "Description"];
  const CustomRow = ({ row }) => {
    return (
      <TableRow
        key={row.id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell width="20%" component="th" scope="row">
          {moment.utc(row.date).format("dddd, MMMM DD, YYYY")}
        </TableCell>
        <TableCell width="20%">
          {row.hours.toString().padStart(2, "0")}:
          {row.minutes.toString().padStart(2, "0")}
        </TableCell>
        <TableCell className="truncate max-w-[250px] grow">{row.description}</TableCell>
      </TableRow>
    );
  };

  const submitTimesheetViaLink = ({ shouldCopy = false }) => {
    if (
      (shouldCopy === false && emails.length === 0) ||
      emails.some((email) => !isEmail(email))
    ) {
      Swal.fire({
        icon: "error",
        title: "Invalid E-Mail",
        text: "Please enter a valid E-Mail address",
      });
      return;
    }

    if (secure) {
      if (!isInt(pin, { min: 0, max: 9999 })) {
        Swal.fire({
          icon: "error",
          title: "Invalid PIN",
          text: "Please enter a valid PIN",
        });
        return;
      }
    }

    generateSecureLink({
      timesheetId: selectedTimesheet,
      numberOfWeeks,
      emails,
      pin,
    }).then((linkId) => {
      if (linkId !== null) {
        const baseUrl = process.env.REACT_APP_BASE_URL === "https://dev.api.prolegion.com" ? "https://dev.prolegion.com" : process.env.REACT_APP_BASE_URL === "https://demo.api.prolegion.com" ? "https://demo.prolegion.com" : "https://prolegion.com"
        if (shouldCopy) {
          navigator.clipboard
            .writeText(`${baseUrl}/timesheet/${linkId}`)
            .then(() =>
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Timesheet Link Copied to Clipboard",
              })
            );
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Timesheet submitted successfully",
          });
        }

        setModalOpen(false);
        setEmails([]);
        setSecure(false);
        setPin("");
      }
    });
  };

  const StatusBadge = () => {
    return (
      <div className="flex flex-row space-x-6 justify-end items-center">
        {status === timesheetStatus.approved ||
          status === timesheetStatus.rejected ? (
          <div
            className="px-2 py-1 rounded-[5px]"
            style={
              status === timesheetStatus.approved
                ? { backgroundColor: "#2EBAA34D", color: "#2EBAA3" }
                : { backgroundColor: "#FF33334D", color: "#FF3333" }
            }
          >
            {status[0] + status.slice(1).toLowerCase()}
          </div>
        ) : status === timesheetStatus.submitted ? (
          <>
            {canApproveTimesheet && (
              <>
                <button
                  className="bg-[#2EBAA3] text-white px-2 py-1.5 rounded-md w-[100px]"
                  onClick={() =>
                    setModal({ open: true, type: timesheetStatus.rejected })
                  }
                >
                  Reject
                </button>
                <button
                  className="bg-[#2EBAA3] text-white px-2 py-1.5 rounded-md w-[100px]"
                  onClick={() =>
                    setModal({ open: true, type: timesheetStatus.approved })
                  }
                >
                  Approve
                </button>
              </>
            )}
            <button
              className="px-2 py-0.5 border border-[#139588] rounded-[8px] text-[#139588] flex items-center gap-x-1"
              onClick={() => setModalOpen(true)}
            >
              <LinkIcon className="w-5 h-5" />
              Submit via Link
            </button>
          </>
        ) : null}
      </div>
    );
  };

  return (
    <div className="relative">
      <div
        className={`flex flex-row gap-x-3 font-medium text-[18px] items-center ${showDatePicker ? "mb-6" : "mb-2"
          }`}
      >
        <Back
          onClick={() => {
            setSelectedTimesheet(null);
            setShowTimesheetDetails?.(false);
            navigate(from ? from : "/dashboard/timesheetscard", { state: { from: { pathname: from ? `/dashboard/${from.split("/")[2]}` : "" } } });
          }}
          className=""
        />
        <span>Timesheet</span>
      </div>

      {showDatePicker ? (
        <div className="flex mb-4 justify-between">
          <div className="flex items-center select-none">
            {/* Left Arrow */}
            <ChevronLeft
              sx={{ fontSize: 28 }}
              className="border-[1px] rounded-md mr-2 border-black cursor-pointer"
              onClick={() => {
                const newDate = moment.utc(date.date).subtract(1, "week");
                console.log(newDate, moment.utc(job.startDate))
                // if (newDate >= moment.utc(job.startDate)) {
                setDate({ date: newDate, fromApi: false });
                setStatus(timesheetStatus.none);

                if (job.id) {
                  fetchTimesheetsByDate({
                    jobId: job.id,
                    startDate: newDate.startOf("week").toISOString(),
                  });
                }
                // }
              }}
            />

            {/* Display Selected Week */}
            <input
              readOnly
              onClick={() => setOpen(!open)}
              className="h-10 w-[350px] text-white bg-[#2EBAA3] p-1 rounded-md border-0 cursor-pointer text-center outline-0"
              value={
                date.date.startOf("week").format("Do MMM, YYYY") +
                " - " +
                date.date.endOf("week").format("Do MMM, YYYY")
              }
            />

            {/* Right Arrow */}
            <ChevronRight
              sx={{ fontSize: 28 }}
              className="border-[1px] rounded-md ml-2 border-black cursor-pointer"
              onClick={() => {
                const newDate = moment.utc(date.date).add(1, "week");
                setDate({ date: newDate, fromApi: false });
                setStatus(timesheetStatus.none);

                if (job.id) {
                  fetchTimesheetsByDate({
                    jobId: job.id,
                    startDate: newDate.startOf("week").toISOString(),
                  });
                }
              }}
            />
          </div>

          <StatusBadge />
        </div>
      ) : (
        <div className="mb-4">
          <StatusBadge />
        </div>
      )}

      {timesheetMaster?.job || currentTimesheet ? (
        <div className="space-y-4">
          {!hideJobInfo && <div
            style={{ border: "1px solid #D9D9D9" }}
            className="flex flex-col bg-white p-4 rounded-md"
          >
            <div className="flex flex-row space-x-4">
              <span style={{ fontWeight: "500" }} className="mr-[39px]">
                Name
              </span>
              <span>
                {timesheetMaster?.job?.name ??
                  currentTimesheet?.job?.name ??
                  "-"}
              </span>
            </div>
            <div className="flex flex-row space-x-4">
              <span style={{ fontWeight: "500" }} className="">
                Description
              </span>
              <span className="text-justify">
                {timesheetMaster?.job?.name
                  ? timesheetMaster?.job?.name
                  : currentTimesheet?.job?.description}
              </span>
            </div>
          </div>}
          <div className="flex flex-row space-x-16 border border-[#D9D9D9] rounded-[8px] bg-white p-4 mb-8">
            {(currentTimesheet?.vendor || timesheetResource?.firstName) && (
              <div className="flex flex-col">
                <span className="font-medium">Vendor</span>
                <div className="flex flex-col bg-white flex-1 rounded-b-lg mt-2">
                  <div
                    style={{
                      width: "287px",
                    }}
                    className="flex flex-row text-black items-center space-x-6 bg-[#CFCFCF] rounded-lg p-2"
                  >
                    <Link
                      to={`/vendor/profile/${timesheetResource?.id ?? currentTimesheet?.vendor?.id
                        }`}
                    >
                      <Avatar
                        className="ml-2"
                        style={{
                          height: "35px",
                          width: "35px",
                        }}
                        {...stringAvatar(
                          `${(timesheetResource?.company ??
                            currentTimesheet?.vendor?.company ??
                            "")
                          }`
                        )}
                        src={
                          timesheetResource?.profilePhoto ??
                          currentTimesheet?.vendor?.profilePhoto ??
                          ""
                        }
                      />
                    </Link>
                    <span className="text-white">
                      {timesheetResource?.company ??
                        currentTimesheet?.vendor?.company ??
                        ""}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="flex flex-row space-x-16">
              <div className="flex flex-col">
                <span className="font-medium">Consultant</span>
                <div className="flex flex-col bg-white flex-1 rounded-b-lg mt-2">
                  <div
                    style={{
                      width: "287px",
                    }}
                    className="flex flex-row items-center space-x-6 bg-[#2EBAA3] rounded-lg p-2"
                  >
                    <Link
                      target="_blank"
                      to={`/consultant/profile/${timesheetMaster?.consultant?.id ??
                        currentTimesheet?.consultant?.id
                        }`}
                    >
                      <Avatar
                        className="ml-2"
                        style={{
                          height: "35px",
                          width: "35px",
                        }}
                        {...stringAvatar(
                          `${(timesheetMaster?.consultant?.firstName ??
                            currentTimesheet?.consultant?.firstName ??
                            "") +
                          " " +
                          (timesheetMaster?.consultant?.lastName ??
                            currentTimesheet?.consultant?.lastName ??
                            "")
                          }`
                        )}
                        src={
                          timesheetMaster?.consultant?.profilePhoto ??
                          currentTimesheet?.consultant?.profilePhoto ??
                          ""
                        }
                      />
                    </Link>
                    <span className="text-white">
                      {timesheetMaster?.consultant?.firstName ??
                        currentTimesheet?.consultant?.firstName ??
                        ""}{" "}
                      {timesheetMaster?.consultant?.lastName ??
                        currentTimesheet?.consultant?.lastName ??
                        ""}
                    </span>
                  </div>
                </div>
              </div>
              {resourceVendor && <div className="flex flex-col">
                <span className="font-medium">Vendor</span>
                <div className="flex flex-col bg-white flex-1 rounded-b-lg mt-2">
                  <div
                    style={{
                      width: "287px",
                    }}
                    className="flex flex-row items-center space-x-6 text-black bg-[#CFCFCF] rounded-lg p-2"
                  >
                    <Link
                      target="_blank"
                      to={`/vendor/profile/${resourceVendor?.id}`}
                    >
                      <Avatar
                        className="ml-2"
                        style={{
                          height: "35px",
                          width: "35px",
                        }}
                        {...stringAvatar(
                          `${(resourceVendor?.company)
                          }`
                        )}
                        src={resourceVendor?.profilePhoto}
                      />
                    </Link>
                    <span className="text-white">
                      {resourceVendor?.company}
                    </span>
                  </div>
                </div>
              </div>}
            </div>
          </div>
        </div>
      ) : null}

      <div className="flex flex-row justify-between">
        {timesheetMaster?.approvalDate ? (
          <div className="flex font-medium mt-4 mb-4 space-x-4">
            {timesheetMaster?.approvalDate &&
              (timesheetMaster?.status === "REJECTED" ||
                timesheetMaster?.status === "APPROVED") && (
                <>
                  <span>
                    {timesheetMaster.status === "REJECTED"
                      ? "Rejected"
                      : "Approved"}{" "}
                    On :{" "}
                  </span>
                  <span className="text-[#139588]">
                    {dayjs(timesheetMaster?.approvalDate)
                      .locale("en")
                      .format("DD MMMM YYYY h:mm A")}
                  </span>
                </>
              )}
          </div>
        ) : (
          <div className="flex font-medium mt-4 mb-4 space-x-4">
            {currentTimesheet?.approvalDate &&
              (currentTimesheet?.status === "REJECTED" ||
                currentTimesheet?.status === "APPROVED") && (
                <>
                  <span>
                    {currentTimesheet.status === "REJECTED"
                      ? "Rejected"
                      : "Approved"}{" "}
                    On :{" "}
                  </span>
                  <span className="text-[#139588]">
                    {dayjs(currentTimesheet?.approvalDate)
                      .locale("en")
                      .format("DD MMMM YYYY h:mm A")}
                  </span>
                </>
              )}
          </div>
        )}

        {timesheetMaster?.approvalDate ? (
          <div className="flex font-medium mt-4 mb-4 space-x-4">
            {timesheetMaster?.approvalDate &&
              (timesheetMaster?.status === "REJECTED" ||
                timesheetMaster?.status === "APPROVED") && (
                <>
                  <span>Comments : </span>
                  <span className="text-[#139588]">
                    {timesheetMaster?.clientComments}
                  </span>
                </>
              )}
          </div>
        ) : (
          <div className="flex font-medium mt-4 mb-4 space-x-4">
            {currentTimesheet?.approvalDate &&
              (currentTimesheet?.status === "REJECTED" ||
                currentTimesheet?.status === "APPROVED") && (
                <>
                  <span>Comments : </span>
                  <span className="text-[#139588]">
                    {currentTimesheet?.clientComments}
                  </span>
                </>
              )}
          </div>
        )}

        {timesheetMaster?.hours ? (
          <div className="flex font-medium mt-4 mb-4 space-x-4">
            <span>Total Hours : </span>
            <span className="text-[#139588]">
              {(timesheetMaster?.hours || timesheetMaster?.minutes) &&
                timesheetMaster.minutes == 0
                ? timesheetMaster.hours + ":00"
                : timesheetMaster.hours + ":" + timesheetMaster.minutes}
            </span>
          </div>
        ) : (
          (currentTimesheet?.hours || currentTimesheet?.minutes) && (
            <div className="flex font-medium mt-4 mb-4 space-x-4">
              <span>Total Hours : </span>
              <span className="text-[#139588]">
                {(currentTimesheet?.hours || currentTimesheet?.minutes) &&
                  currentTimesheet.minutes == 0
                  ? currentTimesheet.hours + ":00"
                  : currentTimesheet.hours + ":" + currentTimesheet.minutes}
              </span>
            </div>
          )
        )}
      </div>

      <CustomTable
        headCells={headCells.map((heading) => ({ label: heading }))}
        rows={rows}
        CustomRow={CustomRow}
        showPagination={false}
        showToolbar={false}
        showDensePadding={false}
      />

      <Modal
        open={modal.open}
        onOk={() => {
          if (selectedTimesheet !== null) {
            if (modal.type === timesheetStatus.rejected) {
              if (comment.length === 0) {
                Swal.fire(
                  "Error",
                  "Please provide a reason for rejection",
                  "error"
                );
              } else {
                rejectTimesheet(selectedTimesheet, comment);
                setStatus(timesheetStatus.rejected);
                setModal({ open: false, type: timesheetStatus.approved });
              }
            } else {
              approveTimesheet(selectedTimesheet, comment);
              setStatus(timesheetStatus.approved);
              setModal({ open: false, type: timesheetStatus.approved });
            }
          }
        }}
        onCancel={() =>
          setModal({ open: false, type: timesheetStatus.approved })
        }
        okButtonProps={{ className: "bg-[#1677FF]" }}
        okText={modal.type === timesheetStatus.rejected ? "Reject" : "Approve"}
        closable={false}
      >
        <p className="font-medium mb-1 ml-0.5">Comments</p>
        <input
          className="w-full text-sm"
          maxLength={250}
          onChange={(e) => setComment(e.target.value)}
        />
      </Modal>

      <Modal
        open={modalOpen}
        title="Submit Timesheet via Link"
        onCancel={() => {
          setModalOpen(false);
          setEmails([]);
          setSecure(false);
          setPin("");
        }}
        footer={
          <div className="flex flex-row justify-between">
            <Button
              onClick={() => submitTimesheetViaLink({ shouldCopy: true })}
              style={{
                border: "1px solid #787878",
                borderRadius: "8px",
                color: "#787878",
                width: "177px",
              }}
            >
              Copy Link
            </Button>
            <Button
              type="primary"
              style={{
                background: "#2EBAA3",
                borderRadius: "8px",
                width: "177px",
              }}
              onClick={() => submitTimesheetViaLink({ shouldCopy: false })}
            >
              Submit
            </Button>
          </div>
        }
      >
        <div className="flex flex-row items-center mb-2 space-x-6">
          <span>Weeks</span>
          <FormControl sx={{ minWidth: 409 }} size="small">
            <InputLabel id="demo-simple-select-autowidth-label">
              Select Weeks
            </InputLabel>
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={numberOfWeeks}
              onChange={handleChange}
              label="Weeks"
            >
              <MenuItem value={1}>Last Week</MenuItem>
              <MenuItem value={2}>Last Two Weeks</MenuItem>
              <MenuItem value={3}>Last Three Weeks</MenuItem>
              <MenuItem value={4}>Last Four Weeks</MenuItem>
            </Select>
          </FormControl>
        </div>
        <Autocomplete
          multiple
          freeSolo
          clearIcon={null}
          clearOnBlur
          onChange={(e, value) =>
            setEmails(value.filter((email) => isEmail(email)))
          }
          value={emails}
          itemType=""
          options={[]}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip label={option} {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => (
            <div className="flex flex-row items-center space-x-8">
              <span>Email</span>
              <Tooltip
                arrow
                title="To add multiple addresses, press enter after each address"
              >
                <TextField
                  {...params}
                  size="small"
                  required
                  label="E-Mail"
                  onBlur={(e) => {
                    if (isEmail(e.target.value)) {
                      if (!emails.includes(e.target.value))
                        setEmails([...emails, e.target.value]);
                    }
                  }}
                  sx={{
                    marginTop: "0.5rem",
                    "& label.Mui-focused": {
                      color: "rgba(0,0,0,0.6)",
                    },
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "rgba(0,0,0,0.87)",
                        borderWidth: "1px",
                      },
                    },
                  }}
                />
              </Tooltip>
            </div>
          )}
        />

        <div className="pl-2">
          <FormControlLabel
            control={
              <Checkbox
                checked={secure}
                onChange={(_, val) => setSecure(val)}
                sx={{ paddingLeft: 0, paddingRight: "0.25rem" }}
                disableRipple
              />
            }
            label="Add Pin (Communicate the pin to client)"
            className="mt-4"
          />
        </div>

        {secure ? (
          <div className="flex space-x-10 items-center">
            <span>PIN</span>
            <TextField
              size="small"
              label="PIN"
              placeholder="Enter a 4-digit PIN"
              sx={{
                marginTop: "0.25rem",
                marginBottom: "0.5rem",
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0.6)",
                },
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "rgba(0,0,0,0.87)",
                    borderWidth: "1px",
                  },
                },
              }}
              maxLength="4"
              value={pin}
              fullWidth
              onChange={(e) => {
                const str = e.target.value;
                if (str.length === 0) {
                  setPin("");
                } else if (isInt(str, { min: 0, max: 9999 })) {
                  setPin(str);
                }
              }}
            />
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default Daywise;
